module.exports = __webpack_public_path__ + "img/add_user.1156d40b.svg";